function beforesubmitFormular(){
    var valid = true;

    if(!$("[name=\"betreff\"]").is(":hidden")){
        if(document.f.betreff.value == cpText.formBetreff + ' *' || document.f.betreff.value == ''){
            displayErrorBox(cpText.formBitteBefuellen + ' ' + cpText.formBetreff + '.');
            document.f.betreff.focus();
            return false;
        }

        if(document.f.nachricht.value == cpText.formNachricht + ' *' || document.f.nachricht.value == ''){
            displayErrorBox(cpText.formBitteBefuellen + ' ' + cpText.formNachricht + '.');
            document.f.nachricht.focus();
            return false;
        }
    }

    if(document.f.anrede.options.selectedIndex == 0){
        displayErrorBox(cpText.formBitteBefuellen + ' ' + cpText.formAnrede + '.');
        document.f.anrede.focus();
        return false;
    }
    if(document.f.vorname.value == cpText.formVorname + ' *' || document.f.vorname.value == ''){
        displayErrorBox(cpText.formBitteBefuellen + ' ' + cpText.formVorname + '.');
        document.f.vorname.focus();
        return false;
    }
    if(document.f.nachname.value == cpText.formNachname + ' *' || document.f.nachname.value == ''){
        displayErrorBox(cpText.formBitteBefuellen + ' ' + cpText.formNachname + '.');
        document.f.nachname.focus();
        return false;
    }
    if(document.f.email.value == cpText.formEmail + ' *' || document.f.email.value == ''){
        displayErrorBox(cpText.formBitteBefuellen + ' ' + cpText.formEmail + '.');
        document.f.email.focus();
        return false;
    }

    if(hx.isValidEmailAddress(document.f.email.value) == false){
        displayErrorBox(cpText.formEmailUngueltig);
        document.f.email.focus();
        return false;
    }

    if($(".captcha_input").val() == ""){
        displayErrorBox(cpText.formBitteBefuellen + ' ' + cpText.formCaptcha + ".");
        $(".captcha_input").focus();
        return false;
    }else{
        $.ajax({
            url:ABSOLUTE_WEBPATH + 'cmshx_template/ajax/check_captcha.php?idp=' + $(".js-form_captcha").data("idp"),
            data:$("form").serialize(),
            type:"POST",
            async: false,
        }).done(function(error){
            if(error != ""){
                displayErrorBox(error);
                $(".captcha_input").focus();
                valid =  false;
            }else{
                valid = true;
            }
        });
    }

    return valid;
}

$(document).ready(function(){
    var $formCaptcha = $(".js-form_captcha");
    var $formCaptchaIcon = $(".js-form_captcha_icon");

    $formCaptchaIcon.on("click", function(){
        $formCaptcha.attr("src", $formCaptcha.data("src") + "&" + Date.now())
    });
});